export default __webpack_public_path__ + "static/media/RedHatDisplay-Regular.c4105783.woff";